import React, { useState } from "react";
import { Link } from "react-router-dom";
import { camelToTitle } from "../../helpers/helpers";
import styles from "./Navbar.module.css";
import ShareIcon from "@atlaskit/icon/glyph/share";
import {
  AtlassianNavigation,
  PrimaryDropdownButton,
  PrimaryButton,
  Help,
  CustomProductHome,
  Settings,
} from "@atlaskit/atlassian-navigation";
import Button from "@atlaskit/button";
import Drawer from "@atlaskit/drawer";
import QuestionCircleIcon from "@atlaskit/icon/glyph/question-circle";
import DocumentsIcon from "@atlaskit/icon/glyph/documents";
import ShortcutIcon from "@atlaskit/icon/glyph/shortcut";
import { ButtonItem } from "@atlaskit/menu";
import Popup from "@atlaskit/popup";

import logo from "../../assets/revyz-logo-svg.png";
import { useLocation } from "react-router-dom";

const Navbar = ({ displayPostInstall, welcomePage, setWelcomePage }) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isSettingOpen, setIsSettingOpen] = useState(false);
  const [helpIsOpen, setHelpIsOpen] = useState(false);
  const AtlassianProductHomeBackup = () => (
    <Link to="/backup">
      <CustomProductHome
        siteTitle={<span>{camelToTitle(location.pathname.split("/")[1])}</span>}
        iconAlt="Revyz data security"
        iconUrl={logo}
        logoAlt="Revyz data security"
        logoUrl={logo}
        logoMaxWidth={300}
      />
    </Link>
  );

  const AtlassianProductHomeRestore = () => (
    <Link to="/restore">
      <CustomProductHome
        siteTitle={camelToTitle(location.pathname.split("/")[1])}
        iconAlt="Revyz data security"
        iconUrl={logo}
        logoAlt="Revyz data security"
        logoUrl={logo}
        logoMaxWidth={300}
      />
    </Link>
  );

  const AtlassianProductPostInstall = () => (
    <CustomProductHome
      href="#"
      siteTitle="Setup"
      iconAlt="Revyz data security"
      iconUrl={logo}
      logoAlt="Revyz data security"
      logoUrl={logo}
      logoMaxWidth={300}
    />
  );

  const PopupContents = () => {
    return (
      <div>
        <Link to="/restore/quickrestore">
          <ButtonItem
            isSelected={location.pathname === "/restore"}
            onClick={() => setIsOpen((prev) => !prev)}
          >
            Quick
          </ButtonItem>
        </Link>
        <Link to="/restore/advrestore">
          <ButtonItem
            isSelected={location.pathname === "/restore/advrestore"}
            onClick={() => setIsOpen((prev) => !prev)}
          >
            Advanced
          </ButtonItem>
        </Link>
      </div>
    );
  };

  const PopupSettingContentBackup = () => {
    return (
      <div>
        <div className={styles.topSettingContent}>
          <h3>Settings</h3>
          <div className={styles.topSettinglist}>
            <div className={styles.Settinglistitem}>
              <Link to="/backup/settings">
                <ButtonItem
                  isSelected={location.pathname === "/backup/settings"}
                  onClick={() => setIsSettingOpen((prev) => !prev)}
                >
                  Backup Settings
                </ButtonItem>
              </Link>
            </div>
            <div className={styles.Settinglistitem}>
              <Link to="/backup/audit">
                <ButtonItem
                  isSelected={location.pathname === "/backup/audit"}
                  onClick={() => setIsSettingOpen((prev) => !prev)}
                >
                  Audit Log
                </ButtonItem>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const helpPopupContents = () => {
    return (
      <div>
        <div className={styles.topcontent}>
          <h3>Revyz data security</h3>
          <div className={styles.toplist}>
            <a
              href="https://revyz.atlassian.net/servicedesk/customer/portal/1"
              target="_blank"
              rel="noreferrer"
            >
              <div className={styles.listitem}>
                <div className={styles.menuitem}>Support </div>
                <ShortcutIcon size="small" />
              </div>
            </a>
            <a
              href="https://support.revyz.io/"
              target="_blank"
              rel="noreferrer"
            >
              <div className={styles.listitem}>
                <div className={styles.menuitem}>Documentation </div>

                <ShortcutIcon size="small" />
              </div>
            </a>
            <a
              href="https://www.revyz.io/earlyaccess"
              target="_blank"
              rel="noreferrer"
            >
              <div className={styles.listitem}>
                <div className={styles.menuitem}>Refer us to a friend</div>

                <ShortcutIcon size="small" />
              </div>
            </a>
          </div>
          <div className={styles.toplist}>
            <a
              href="https://support.revyz.io/legal-security/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              <div className={styles.listitem}>
                <div className={styles.menuitem}>Privacy Policy </div>
                <ShortcutIcon size="small" />
              </div>
            </a>
            <a
              href="https://support.revyz.io/legal-security/"
              target="_blank"
              rel="noreferrer"
            >
              <div className={styles.listitem}>
                <div className={styles.menuitem}>Terms of Use </div>
                <ShortcutIcon size="small" />
              </div>
            </a>
            <a href="https://revyz.io/" target="_blank" rel="noreferrer">
              <div className={styles.listitem}>
                <div className={styles.menuitem}>About us </div>
                <ShortcutIcon size="small" />
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  };

  const PopupSettingContentRestore = () => {
    return (
      <div>
        <div className={styles.topSettingContent}>
          <h3>Settings</h3>
          <div className={styles.topSettinglist}>
            <div className={styles.Settinglistitem}>
              <Link to="/restore/audit">
                <ButtonItem
                  isSelected={location.pathname === "/restore/audit"}
                  onClick={() => setIsSettingOpen((prev) => !prev)}
                >
                  Audit Log
                </ButtonItem>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const HelpDropdown = (props) => {
    return (
      <Popup
        content={() => helpPopupContents()}
        isOpen={helpIsOpen}
        placement="bottom-start"
        onClose={() => setHelpIsOpen(false)}
        trigger={(triggerProps) => (
          <div
            {...triggerProps}
            onClick={() => {
              setHelpIsOpen(!helpIsOpen);
              if (isSettingOpen) setIsSettingOpen(!isSettingOpen);
            }}
          >
            <Help
              onClick={() => {
                setHelpIsOpen(true);
                if (isSettingOpen) setIsSettingOpen(false);
              }}
              tooltip="Get help"
            />
          </div>
        )}
      />
    );
  };
  const ExploreDropdown = (props) => {
    return (
      <Popup
        content={() => PopupContents()}
        isOpen={isOpen}
        placement="bottom-start"
        onClose={() => setIsOpen(false)}
        shouldUseCaptureOnOutsideClick={true}
        trigger={(triggerProps) => (
          <PrimaryDropdownButton
            {...triggerProps}
            isSelected={isOpen}
            onClick={() => setIsOpen((prev) => !prev)}
            isHighlighted={
              location.pathname === "/restore/advrestore" ||
              location.pathname === "/restore/quickrestore"
            }
          >
            Restore
          </PrimaryDropdownButton>
        )}
      />
    );
  };

  const SettingDropDown = () => {
    return (
      <div style={{ height: "55px" }}>
        <PrimaryButton
          isHighlighted={
            location.pathname === "/backup/settings" ||
            location.pathname === "/backup/audit" ||
            location.pathname === "/restore/audit"
          }
        >
          <Popup
            isOpen={isSettingOpen}
            onClose={() => setIsSettingOpen(false)}
            placement="bottom-start"
            content={() =>
              location.pathname.split("/")[1] === "backup" ? (
                <PopupSettingContentBackup />
              ) : (
                <PopupSettingContentRestore />
              )
            }
            trigger={(triggerProps) => (
              <Settings
                {...triggerProps}
                style={
                  isSettingOpen ||
                  location.pathname === "/backup/settings" ||
                  location.pathname === "/backup/audit" ||
                  location.pathname === "/restore/audit"
                    ? {
                        color: "#0052CC",
                        backgroundColor: "rgba(222, 235, 255, 8, 9)",
                      }
                    : {}
                }
                onClick={() => {
                  setIsSettingOpen(!isSettingOpen);
                  setHelpIsOpen(false);
                }}
              />
            )}
          />
        </PrimaryButton>
      </div>
    );
  };
  return (
    <div>
      <Drawer width={"narrow"} onClose={() => setOpen(false)} isOpen={open}>
        <div className={styles.drawercontainer}>
          <div className={styles.topcontent}>
            <h3>Revyz data security</h3>
            <ul className={styles.drawerlist}>
              <a
                href="https://revyz-support.atlassian.net/servicedesk/customer/portal/1"
                target="_blank"
                rel="noreferrer"
              >
                <li className={styles.horizontalalign}>
                  <QuestionCircleIcon size="medium" />
                  Support <ShortcutIcon size="small" />
                </li>
              </a>
              <a
                href="https://support.revyz.io/"
                target="_blank"
                rel="noreferrer"
              >
                <li className={styles.horizontalalign}>
                  <DocumentsIcon size="medium" />
                  Documentation <ShortcutIcon size="small" />
                </li>
              </a>
              <a
                href="https://www.revyz.io/earlyaccess"
                target="_blank"
                rel="noreferrer"
              >
                <li className={styles.horizontalalign}>
                  <ShareIcon size="medium" />
                  Refer us to a friend <ShortcutIcon size="small" />
                </li>
              </a>
            </ul>
          </div>
          <ul className={styles.bottomlist}>
            <a
              href="https://support.revyz.io/legal-security/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              <li className={styles.horizontalalign}>
                Privacy Policy <ShortcutIcon size="small" />
              </li>
            </a>
            <a
              href="https://support.revyz.io/legal-security/"
              target="_blank"
              rel="noreferrer"
            >
              <li className={styles.horizontalalign}>
                Terms of Use <ShortcutIcon size="small" />
              </li>
            </a>
            <a href="https://revyz.io/" target="_blank" rel="noreferrer">
              <li className={styles.horizontalalign}>
                About us <ShortcutIcon size="small" />
              </li>
            </a>
          </ul>
        </div>
      </Drawer>
      {!welcomePage && <div className={styles.patti}></div>}

      {location.pathname.split("/")[1] === "backup" ? (
        <div className={styles.navbarmain}>
          {/* backup navigation */}
          <AtlassianNavigation
            label="site"
            primaryItems={[
              <Link to="/backup">
                <PrimaryButton isHighlighted={location.pathname === "/backup"}>
                  Dashboard
                </PrimaryButton>
              </Link>,
              <Link to="/backup/insights">
                <PrimaryButton
                  isHighlighted={location.pathname === "/backup/insights"}
                >
                  Insights
                </PrimaryButton>
              </Link>,
              <Link to="/backup/jobs">
                <PrimaryButton
                  isHighlighted={location.pathname === "/backup/jobs"}
                >
                  Jobs
                </PrimaryButton>
              </Link>,
              <Link to="/backup/trigger">
                <PrimaryButton
                  isHighlighted={location.pathname === "/backup/trigger"}
                >
                  Backup
                </PrimaryButton>
              </Link>,
              // <Link to="/backup/settings">
              //   <PrimaryButton
              //     isHighlighted={location.pathname === "/backup/settings"}
              //   >
              //     Settings
              //   </PrimaryButton>
              // </Link>,
            ]}
            // renderSettings={() => <Button appearance='subtle' onClick={() => setOpen(true)} tooltip="Get help" >Refer to Team</Button>}
            renderHelp={() => (
              <HelpDropdown onClick={() => setHelpIsOpen(true)} />
            )}
            renderSettings={() => <SettingDropDown />}
            renderProductHome={AtlassianProductHomeBackup}
          />
        </div>
      ) : location.pathname.split("/")[1] === "restore" ? (
        // Restore navigation
        <div className={styles.navbarmain}>
          <AtlassianNavigation
            label="site"
            primaryItems={[
              <Link to="/restore">
                <PrimaryButton isHighlighted={location.pathname === "/restore"}>
                  Dashboard
                </PrimaryButton>
              </Link>,
              <Link to="/restore/jobs">
                <PrimaryButton
                  isHighlighted={location.pathname === "/restore/jobs"}
                >
                  Jobs
                </PrimaryButton>
              </Link>,
              <ExploreDropdown />,
            ]}
            renderHelp={() => (
              <HelpDropdown onClick={() => setHelpIsOpen(true)} />
            )}
            renderSettings={() => <SettingDropDown />}
            renderProductHome={AtlassianProductHomeRestore}
          />
        </div>
      ) : (
        !welcomePage && (
          <div className={styles.navbarmain}>
            <AtlassianNavigation
              label="site"
              renderHelp={() => (
                <div className={styles.helpPostInstall}>
                  Having trouble?&nbsp;
                  <a
                    href="https://revyz-support.atlassian.net/servicedesk/customer/portal/1"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "#0052cc" }}
                  >
                    <strong>Get Help</strong>
                  </a>
                </div>
              )}
              renderProductHome={AtlassianProductPostInstall}
            />
          </div>
        )
      )}
    </div>
  );
};

export default Navbar;
